<template>
    <div class="app-wrapper">
        <headerMain></headerMain>
        <app-main></app-main>
        <el-row :gutter="20" class="app-container">
            <el-col :md="7" :sm="9"><a target="_blank" href="https://isfg.ru/politika-obrabotki-personalnykh-dannykh" style="margin: 5px 0;font-size: 12px;">Политика обработки персональных данных</a></el-col>
            <el-col :md="17" :sm="15"><a target="_blank" href="https://isfg.ru/usloviya-peredachi-dannykh" style="margin: 5px 0;font-size: 12px;">Условия передачи данных</a></el-col>
        </el-row>
    </div>

</template>

<script>

    import appMain from "./components/appMain";
    import headerMain from "./components/headerMain";
    export default {
        name: "index",
        components:
            {
                appMain,
                headerMain
            }
    }
</script>

<style scoped>

</style>